import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import AuthService from "src/helpers/AuthService";

export interface IProtectedRouteProps extends RouteProps {
  authenticationPath: string;
}

export class ProtectedRoute extends Route<IProtectedRouteProps> {
  public render() {
    let redirectPath: string = "";
    if (!new AuthService().isLoggedIn()) {
      redirectPath = this.props.authenticationPath;
    }

    if (redirectPath) {
      // tslint:disable-next-line:no-console
      const renderComponent = () => (
        <Redirect
          to={{ pathname: redirectPath, state: { from: this.props.path } }}
        />
      );
      return (
        <Route {...this.props} component={renderComponent} render={undefined} />
      );
    } else {
      return <Route {...this.props} />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/ProtectedRoute.tsx